import * as React from "react";
import Button from "@mui/material/Button";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Grow from "@mui/material/Grow";
import Paper from "@mui/material/Paper";
import Popper from "@mui/material/Popper";
import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";
import Stack from "@mui/material/Stack";
import { Link } from "react-router-dom";

export default function MenuListComposition() {
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  function handleListKeyDown(event) {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpen(false);
    } else if (event.key === "Escape") {
      setOpen(false);
    }
  }

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = React.useRef(open);
  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = open;
  }, [open]);

  return (
    <Stack direction="column" spacing={2}>
      <div>
        <Button
          ref={anchorRef}
          id="composition-button"
          aria-controls={open ? "composition-menu" : undefined}
          aria-expanded={open ? "true" : undefined}
          aria-haspopup="true"
          onClick={handleToggle}
          style={{
            fontFamily: "var(--mainFont)",
            color: "#000",
            fontWeight: "600",
            fontSize: "16px",
          }}
        >
          الأقسام
          <i
            className="fas fa-chevron-down"
            style={{ marginRight: "10px" }}
          ></i>
        </Button>
        <Popper
          open={open}
          anchorEl={anchorRef.current}
          role={undefined}
          placement="bottom-start"
          transition
          disablePortal
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{
                transformOrigin:
                  placement === "bottom-start" ? "left top" : "left bottom",
              }}
            >
              <Paper>
                <ClickAwayListener onClickAway={handleClose}>
                  <MenuList
                    autoFocusItem={open}
                    id="composition-menu"
                    aria-labelledby="composition-button"
                    onKeyDown={handleListKeyDown}
                    style={{
                      direction: "rtl",
                      display: "flex",
                      flexFlow: "column wrap",
                    }}
                  >
                    <Link to={"/"}>
                      <MenuItem
                        style={{
                          width: "170px",
                          fontFamily: "var(--mainFont)",
                        }}
                      >
                        الدواجن
                      </MenuItem>
                    </Link>
                    <Link to={"/"}>
                      <MenuItem
                        style={{
                          width: "170px",
                          fontFamily: "var(--mainFont)",
                        }}
                      >
                        الألبان والأجبان
                      </MenuItem>
                    </Link>
                    <Link to={"/catagories/fruits"}>
                      <MenuItem
                        style={{
                          width: "170px",
                          fontFamily: "var(--mainFont)",
                        }}
                      >
                        الفواكه والخضروات
                      </MenuItem>
                    </Link>
                    <Link to={"/"}>
                      <MenuItem
                        style={{
                          width: "170px",
                          fontFamily: "var(--mainFont)",
                        }}
                      >
                        الحلويات
                      </MenuItem>
                    </Link>
                    <Link to={"/"}>
                      <MenuItem
                        style={{
                          width: "170px",
                          fontFamily: "var(--mainFont)",
                        }}
                      >
                        المشغولات اليدوية
                      </MenuItem>
                    </Link>
                    <Link to={"/"}>
                      <MenuItem
                        style={{
                          width: "170px",
                          fontFamily: "var(--mainFont)",
                        }}
                      >
                        الوجبات الخفيفة
                      </MenuItem>
                    </Link>
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </div>
    </Stack>
  );
}
